import React, { useEffect, useState } from "react";
import Personalinfo from "./Personalinfo";
import { Container, Col, Row, Modal, CloseButton } from "react-bootstrap";
import LeaveApplication from "./LeaveApplication";
import axios from "axios";
import { LeaveManagmentAPIs } from "../LeaveManagmentAPIs";
import { UserConsumer } from "../../../UserContext";
import { faInfo } from "@fortawesome/free-solid-svg-icons";
import { useParams, useHistory } from "react-router-dom";
import { AlertPopups } from "../../../components/AlertPopups";
import FormStatus from "../../../components/FormStatus";
import { Routes } from "../../../configurations/config";

const Leavelayout = () => {
	let history = useHistory();
	const { id } = useParams();
	let token = null;
	const [personalInformation, setpersonalInformation] = useState({});
	const {
		employeeName,
		employeeCode,
		employeeDepartment,
		employeeEmergencyContactAddress,
		employeeEmergencyContactPhone1,
		employeeEmergencyContactPhone2,
		employeeEmergencyContactName,
	} = personalInformation;
	const [leaveDetailData, setleaveDetailData] = useState([]);
	const [modalShow, setmodalShow] = useState(false);
	const [changeEvent, setChangeEvent] = useState(false);
	const [updateEmergContact, setupdateEmergContact] = useState({
		empEmergContactPhone1: "",
		empEmergContactPhone2: "",
		empEmerContactName: " ",
		empEmerContactAdd: " ",
	});
	const [flag, setflag] = useState(false);
	const [submitButtonEnable, setSubmitButtonEnable] = useState(false);
	const [formStatus, setFormStatus] = useState("");
	const onHide = () => {
		setmodalShow(false);
	};

	useEffect(() => {
		const header = { Authorization: `Bearer ${token}` };
		if (id) {
			axios
				.get(`${LeaveManagmentAPIs.GetLeave}/${id}`, {
					headers: header,
				})
				.then((res) => {
					setleaveDetailData(res.data);
				});
		} else setmodalShow(true);
		axios
			.get(
				`${LeaveManagmentAPIs.GetMyPersonalInfoAndEmergencyContactAPI}`,
				{
					headers: header,
				}
			)
			.then((res) => {
				setpersonalInformation(res.data);
			});
	}, []);

	const updateContacthandleChange = (e) => {
		if (e) {
			setSubmitButtonEnable(true);
			setChangeEvent(true);
		}
		setupdateEmergContact({
			...updateEmergContact,
			[e.target.name]: e.target.value,
		});
	};
	const updateEmgContact = () => {
		const body = {
			employeeEmergencyContactName: updateEmergContact.empEmerContactName,
			employeeEmergencyContactAddress:
				updateEmergContact.empEmerContactAdd,
			employeeEmergencyContactPhone1:
				updateEmergContact.empEmergContactPhone1,
			employeeEmergencyContactPhone2:
				updateEmergContact.empEmergContactPhone2,
		};
		updateEmergContact &&
			changeEvent &&
			axios
				.post(`${LeaveManagmentAPIs.UpdateEmergencyContactAPI}`, body, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then(({ status }) => {
					if (status === 200) {
						AlertPopups.successAlert.fire({
							text: "Emergency Contact Updated Successfully",
						});
						window.location.reload(false);
					} else {
						AlertPopups.ErrorAlert.fire({
							text: "Leave Application Submission Error",
						});
					}
				})
				.catch((err) => {
					if (err.response) {
						AlertPopups.ErrorAlert.fire({
							text: ` ${err.response.data.message}`,
						});
					}
					setSubmitButtonEnable(false);
				});
		setflag(false);
		setSubmitButtonEnable(false);
	};

	//Update btn
	const updateBtn = () => {
		setflag(!flag);
		setSubmitButtonEnable(true);
		axios
			.get(
				`${LeaveManagmentAPIs.GetMyPersonalInfoAndEmergencyContactAPI}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then(({ data }) => {
				setupdateEmergContact({
					empEmerContactAdd: data.employeeEmergencyContactAddress,
					empEmerContactName: data.employeeEmergencyContactName,
					empEmergContactPhone1: data.employeeEmergencyContactPhone1,
					empEmergContactPhone2: data.employeeEmergencyContactPhone2,
				});
			});
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return personalInformation ? (
					<div className="leaveManagment">
						<Container fluid>
							<FormStatus
								title={
									formStatus === "Draft"
										? "Request Leave"
										: "Requested Leave"
								}
								className="createLeaveTitle"
								onClick={() => {
									history.push(Routes.ManageLeavesView);
								}}
								setmodalShow={() => setmodalShow(true)}
								informationIcon={faInfo}
								formStatus={formStatus}
								navigateBack={true}
							/>

							<Row>
								<Col className="personal-info-container d-flex justify-content-between">
									<Personalinfo
										employeeName={employeeName}
										empInfo={true}
										empCode={employeeCode}
										empDepartment={employeeDepartment}
									/>
									<Personalinfo
										empEmerContactPhone1={
											employeeEmergencyContactPhone1
										}
										empEmerContactPhone2={
											employeeEmergencyContactPhone2
										}
										empEmerContactAdd={
											employeeEmergencyContactAddress
										}
										empEmerContactName={
											employeeEmergencyContactName
										}
										personalInformation={
											personalInformation
										}
										updateEmgContact={updateEmgContact}
										updateContacthandleChange={
											updateContacthandleChange
										}
										flag={flag}
										updatebtn={updateBtn}
										updateEmergContact={updateEmergContact}
										submitButtonEnable={submitButtonEnable}
									/>
								</Col>
							</Row>
							<Modal
								size="lg"
								aria-labelledby="contained-modal-title-vcenter"
								centered
								show={modalShow}
								onHide={onHide}
								className="imp-info-PopUp"
							>
								<Modal.Header>
									<Modal.Title
										id="contained-modal-title-vcenter"
										className="imp-info-title"
									>
										Important Information
									</Modal.Title>
									<CloseButton onClick={onHide} />
								</Modal.Header>
								<Modal.Body>
									<ol>
										<li>
											Less than 3 hours presence on a
											working day has to be supported by a
											full day leave
										</li>
										<li>
											Between 3 to 5 hours working will
											raise a short leave situation
										</li>
										<li>
											Equal and less than 3 days planned
											leave request must be submitted at
											least 1 week in advance
										</li>
										<li>
											In case of more than 3 days planned
											leave, the employee must submit the
											leave request to respective manager
											4 weeks in advance{" "}
										</li>
										<li>
											Sick Leaves for more than 3 days
											must be accompanied by relevant
											evidence{" "}
										</li>
										<li>
											All public holidays are excluded{" "}
										</li>
										<li>
											Calendar 1 (Quota 12 Annual & 4 Sick
											Leaves)
											<br /> &#x2022; From 01-Mar-2xx to
											31-Aug-2xx <br /> And Calendar 2
											(Quota 11 Annual & 4 Sick Leaves)
											<br />
											&#x2022; From 01-Sep-2xx to
											29-Feb-xx
										</li>
										<li>
											Maximum 5 Leaves to be carried
											forward to next half
										</li>
										<li>
											Compensation Leaves needs to be
											availed within 90 days after its
											occurrence
										</li>
										<li>
											For more details about policy,
											kindly read & access at:{" "}
											<a
												href="https://teo1dk-portal1.sharepoint.com/HR%20Policies/Forms/AllItems.aspx?viewpath=%2FHR%20Policies%2FForms%2FAllItems%2Easpx"
												target="_blank"
												rel="noopener noreferrer"
											>
												PK Policies
											</a>
										</li>
									</ol>
								</Modal.Body>
							</Modal>
							<LeaveApplication
								emgContact={personalInformation}
								leaveDetailData={leaveDetailData}
								FormStatus={setFormStatus}
							/>
						</Container>
					</div>
				) : (
					<div>Loading</div>
				);
			}}
		</UserConsumer>
	);
};

export default Leavelayout;
